export default "__VITE_ASSET__f0ded1fe__"